export default __webpack_public_path__ + "img/portrait_1.795b2b19ea59d414297e3ef2fd060a0d.jpg";